/**
 * Fatura em aberto cujo boleto atual JÁ FOI BAIXADO no Sicoob (#6124).
 *
 * Casos que originaram (28/09/2026): Gislane (fatura 685, boleto 117) e Nilson
 * (fatura 702, boleto 128) tiveram o boleto da Associação baixado por engano — o
 * cancelamento de outra fatura, da conta Gestão, foi para a conta errada. No
 * sistema as faturas seguiam "Vencido" mostrando o boleto, a linha digitável e o
 * PIX, que o banco recusa. O mesmo vale para as faturas do Elias (4034, 5537):
 * baixadas ao marcar Quitado e depois voltaram a Vencido.
 *
 * Fonte: `boleto_cancelamento_fila` concluída para o MESMO nosso número na MESMA
 * conta. Só leitura — a tela avisa e esconde o que não funciona; não mexe no boleto.
 * Fatura Parcelada/Paga/Quitada/Cancelada fica de fora: ali o boleto baixado é o
 * esperado (o acordo ou a quitação substituiu).
 */

export interface FaturaBoletoAtual {
    num_cobranca_boleto?: string | number | null;
    conta_sicoob?: string | null;
    status_boleto_vigor?: string | null;
}

export interface CancelamentoFila {
    num_cobranca_boleto: string | number | null;
    conta_sicoob: string | null;
    status: string | null;
    processado_em?: string | null;
}

const STATUS_BAIXA_ESPERADA = ['parcelado', 'pago', 'quitado', 'cancelado'];
const conta = (c: string | null | undefined) => (c || 'associacao').trim().toLowerCase();

/** O cancelamento concluído que matou o boleto atual, ou null. */
export function boletoBaixadoNoBanco(
    fatura: FaturaBoletoAtual,
    fila: readonly CancelamentoFila[],
): CancelamentoFila | null {
    const numero = String(fatura.num_cobranca_boleto ?? '').trim();
    if (!numero) return null;
    if (STATUS_BAIXA_ESPERADA.includes(String(fatura.status_boleto_vigor ?? '').trim().toLowerCase())) return null;
    return fila.find(q =>
        q.status === 'concluido'
        && String(q.num_cobranca_boleto ?? '').trim() === numero
        && conta(q.conta_sicoob) === conta(fatura.conta_sicoob),
    ) ?? null;
}
